// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1F-Ut","loaderOuter":"PageOverlayLoader_loaderOuter__152rT"};